<template>
  <el-dialog :visible.sync="visible" title="查看" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="标题" prop="title">
        <el-input v-model="dataForm.title" readonly placeholder=""></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="类型" prop="type">
            <el-radio-group disabled v-model="dataForm.type">
              <el-radio :label="exposureType.exposure">曝光</el-radio>
              <el-radio :label="exposureType.fabulous">点赞</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item  label="审核状态" prop="auditStatus">
            <el-radio-group  disabled v-model="dataForm.auditStatus">
              <el-radio :label="auditStatus.examine">审核中</el-radio>
              <el-radio :label="auditStatus.passed">已通过</el-radio>
              <el-radio :label="auditStatus.fail">未通过</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="内容描述" prop="resubmit">
        <el-input readonly v-model="dataForm.context"></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="上传人员">
            <el-input v-model="dataForm.teacherName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="通过时间">
            <el-input v-model="dataForm.passTime" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="browseNum" label="浏览量" header-align="center" align="center">
            <el-input v-model="dataForm.browseNum" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="点赞量">
            <el-input v-model="dataForm.sponsorNum" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="驳回原因">
        <el-input readonly v-model="dataForm.rejectionReason"></el-input>
      </el-form-item>
      <el-form-item label="重新提交">
        <el-input readonly v-model="dataForm.resubmit"></el-input>
      </el-form-item>
      <el-form-item label="推送对象">
        <el-tag v-for="object in dataForm.pushObjectList" :key="object">{{object == 1?"教师" : "家长"}}</el-tag>
      </el-form-item>
      <el-form-item label="图片">
        <el-image style="height:160px;width: 240px;margin-left: 20px" v-for="src in dataForm.imgList" :key="src" :src="src" fit="cover"></el-image>
      </el-form-item>
      <el-form-item v-if="$hasPermission('exposure:exposure:sponsorNum')"  label="点赞数">
        <el-input readonly v-model="dataForm.sponsorNum" placeholder="点赞数"></el-input>
      </el-form-item>
      <el-form-item v-if="$hasPermission('exposure:exposure:browseNum')"  label="浏览数">
        <el-input readonly v-model="dataForm.browseNum" placeholder="浏览数"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { exposureType, auditStatus } from '../../../constant'

export default {
  data () {
    return {
      visible: false,
      exposureType,
      auditStatus,
      dataForm: {
        id: '',
        title: '',
        type: '',
        teacherName: '',
        teacherId: '',
        auditStatus: '',
        rejectionReason: '',
        isRestart: '',
        resubmit: '',
        passTime: '',
        isTop: '',
        isShare: '',
        pushObject: '',
        sponsorNum: '',
        browseNum: '',
        creator: '',
        updater: '',
        createDate: '',
        updateDate: '',
        imgList: '',
        context: '',
        schoolId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/exposure/exposure/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/exposure/exposure/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
